/**
 * Join an OpenAPI collection base (which may end with `/`) with one or more
 * relative path segments without producing double slashes.
 *
 * @example
 * joinApiPath('/issue/rfis', '{resource_id}', 'attachments')
 * // => '/issue/rfis/{resource_id}/attachments'
 */
export const joinApiPath = (base: string, ...segments: string[]): string =>
  [base.replace(/\/+$/, ''), ...segments.map((segment) => segment.replace(/^\/+|\/+$/g, ''))]
    .filter(Boolean)
    .join('/');
